export const SeparatedFormKeys = [
  [
    'clientName',
    'incidentType',
    'dateOfIncidentIntro',
    'demandAmount',
    'defendantNames',
  ],
  [
    'bioAdvancedMode',
    'bioExplanation',
    'bioAdditionalPrompt',
    'clientAge',
    'maritalStatus',
    'haveSpouse',
    'spouseName',
    'haveChildren',
    'children',
    'clientDidForEmployment',
    'activitiesEnjoyed',
    'additionalInfoBio',
  ],
  [
    'factsAdvancedMode',
    'factsExplanation',
    'factsAdditionalPrompt',
    'plaintiffsName',
    'plaintiffDestination',
    'vehicle',
    'wreckDetails',
    'plaintiffCompanion',
    'plaintiffType',
    'defendantDidWrong',
    'defendantInsurance',
    'whatHappenedAfterIncident',
    'didPoliceCome',
    'didAmbulanceCome',
    'defendantIssuedCitation',
    'didPlaintiffLeaveInAmbulance',
    'whereDidPlaintiffLeave',
    'otherImportantFacts',
    'additionalInfoFacts',
  ],
  [
    'liabilityAdvancedMode',
    'liabilityExplanation',
    'negligenceAdditionalPrompt',
    'employeeDriverInvolved',
    'driverEmploymentStatus',
    'faultReason',
    'defendantDriverWasDrivingBehalfOf',
    'defendantWasNegligentReasons',
    'includeGrossNegligence',
    'causeOfGrossNegligence',
    'additionalInfoLiability',
  ],
  ['medicalTimeline', 'additionalInfoMT', 'medicalAdditionalPrompt'],
  [
    'damagesAdvancedMode',
    'damagesExplanation',
    'economicDamagesAdditionalPrompt',
    'economicDamages',
    'incomeLost',
    'clientProffesion',
    'futureEarningCapacityImpact',
    'futureEarningCapacityMissed',
    'askedAmountForFutureLoss',
    'askedAmountForPastMedicalBills',
    'howWasCalculated',
    'additionalInfoLOE',
    'pastBills',
    'futureBills',
    'lossOfIncome',
  ],
  [
    'noeDamagesAdvancedMode',
    'noeDamagesExplanation',
    'nonEconomicDamagesAdditionalPrompt',
    'injuriesDescription',
    'activitiesClientCantDo',
    'lifeEventsMissed',
    'disfigurement',
    'currentPhysicalLimitations',
    'potentialPhysicalLimitations',
    'mentalAnguish',
    'potentialMentalAugish',
    'describePain',
    'potentialPain',
    'relationshipsAffected',
    'fearFromIncident',
    'citations',
    'additionalInfoNED',
  ],
  [],
  [
    'demandSentDate',
    'demandSendMethod',
    'addressedTo',
    'address',
    'isInsured',
    'adjusterAddress',
    'claimNumber',
    'dateOfIncident',
    'displayGreeting',
    'additionalInfoSalutation',
    'customInstruction',
  ],
  ['documentsList'],
  ['filesWithAllInfo'],
  [],
];

interface IntroductionForm {
  clientName: string;
  incidentType: string;
  dateOfIncidentIntro: Date;
  incidentDescription: string;
  introductionExplanation: string;
  introductionAdvancedMode: boolean;
  defendantNames: defendantName[];
  incidentState: string;
  addressee: string;
  claimNumber: string;
  insured: string;
  // ZLAYT-1432: recipient block of the demand letter.
  insuranceCompany: string;
  recipientAddress: string;
  recipientEmail: string;
  deliveryMethod: string;
}

interface BiographyForm {
  clientNameBio: string;
  clientAge: string;
  maritalStatus: string;
  haveSpouse: boolean;
  spouseName: string;
  haveChildren: boolean;
  children: Child[];
  clientDidForEmployment: string;
  activitiesEnjoyed: string;
  additionalInfoBio: string;
  bioExplanation: string;
  bioAdvancedMode: boolean;
  bioAdditionalPrompt: string;
  client_images: (File | SectionFile)[];
}
interface FactsForm {
  plaintiffsName: string;
  plaintiffDestination: string;
  vehicle: string;
  wreckDetails: string;
  plaintiffCompanion: string;
  plaintiffType: string; // Consider creating an enum type for this
  defendantDidWrong: string;
  defendantInsurance: string;
  whatHappenedAfterIncident: string;
  didPoliceCome: string;
  didAmbulanceCome: string;
  defendantIssuedCitation: string;
  didPlaintiffLeaveInAmbulance: string;
  whereDidPlaintiffLeave: string;
  otherImportantFacts: string;
  additionalInfoFacts: string;
  factsExplanation: string;
  factsAdvancedMode: boolean;
  factsAdditionalPrompt: string;
}

interface LiabilityForm {
  employeeDriverInvolved: string;
  driverEmploymentStatus: string;
  faultReason: string;
  defendantDriverWasDrivingBehalfOf: string;
  defendantWasNegligentReasons: string;
  includeGrossNegligence: string;
  causeOfGrossNegligence: string;
  additionalInfoLiability: string;
  liabilityExplanation: string;
  liabilityAdvancedMode: boolean;
  negligenceAdditionalPrompt: string;
}

interface MedicalTreatmentForm {
  medicalTimeline: string;
  additionalInfoMT: string;
  medicalAdditionalPrompt: string;
  medical_timeline_file: (File | SectionFile)[];
  medical_record_file: (File | SectionFile)[];
}
interface DamagesForm {
  damagesAdvancedMode: boolean;
  economicDamages: string;
  additionalInfoDamages: string;
  incomeLost: string;
  clientProffesion: string;
  futureEarningCapacityImpact: string;
  futureEarningCapacityMissed: string;
  askedAmountForFutureLoss: string;
  askedAmountForPastMedicalBills: string;
  howWasCalculated: string;
  pastBills: string;
  futureBills: string;
  lossOfIncome: string;
  additionalInfoLOE: string;
  damagesExplanation: string;
  economicDamagesAdditionalPrompt: string;
}

interface NOEDamagesForm {
  injuriesDescription: string;
  activitiesClientCantDo: string;
  simple_text: string;
  lifeEventsMissed: string;
  disfigurement: string;
  currentPhysicalLimitations: string;
  potentialPhysicalLimitations: string;
  mentalAnguish: string;
  potentialMentalAugish: string;
  describePain: string;
  potentialPain: string;
  relationshipsAffected: string;
  fearFromIncident: string;
  citations: string;
  anythingElse: string;
  additionalInfoNED: string;
  noeDamagesExplanation: string;
  noeDamagesAdvancedMode: boolean;
  nonEconomicDamagesAdditionalPrompt: string;
}

interface LOEForm {
  incomeLost: string;
  clientProffesion: string;
  futureEarningCapacityImpact: string;
  futureEarningCapacityMissed: string;
  askedAmountForFutureLoss: string;
  askedAmountForPastMedicalBills: string;
  howWasCalculated: string;
  additionalInfoLOE: string;
  LOEExplanation: string;
  LOEAdvancedMode: boolean;
  customInstruction: string;
}

interface DemandFormType {
  demandAmount: string;
  deadlineToRespond: Date;
  additionalInfoDemand: string;
  demandExplanation: string;
  demandAdvancedMode: boolean;
  customInstruction: string;
}
interface SalutationForm {
  demandSentDate: Date;
  demandSendMethod: string;
  addressedTo: string;
  address: string;
  isInsured: boolean;
  adjusterAddress: string;
  claimNumber: string;
  dateOfIncident: Date;
  displayGreeting: boolean;
  additionalInfoSalutation: string;
  salutationExplanation: string;
  salutationAdvancedMode: boolean;
  customInstruction: string;
}

interface AttachmentsForm {
  documentsList: string;
  attachmentsAdvancedMode: boolean;
}
interface UploadFilesForm {
  filesWithAllInfo: ImageFile[];
  filesAdvancedMode: boolean;
}
export interface DemandForm
  extends IntroductionForm,
    BiographyForm,
    FactsForm,
    LiabilityForm,
    MedicalTreatmentForm,
    DamagesForm,
    NOEDamagesForm,
    LOEForm,
    DemandFormType,
    SalutationForm,
    AttachmentsForm,
    UploadFilesForm {}

// Child structure for 'children' array
interface Child {
  name: string;
  age: string;
  gender: string; // Consider creating an enum type for this
}

export interface ImageFile {
  name: string;
  url: string;
}

export interface defendantName {
  id?: string;
  name: string;
}
